import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class CmDetail extends ModelBase {
  public static readonly type = 'CmDetail';
  public readonly type = CmDetail.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('event_id')
  public eventId: number;

  @autoserializeAs('name')
  public name: string;

  @autoserializeAs('tel_no')
  public telNo: string;

  @autoserializeAs('email')
  public email: string;

}
